import Portal from '@zocdoc/components/src/Portal';
import { Breakpoints, getWindowBreakpoint } from '@zocdoc/components/src/grid';
import PropTypes from 'prop-types';
import React from 'react';
import { injectIntl } from 'react-intl';
import withInsuranceValidation from '../../../gql/withInsuranceValidation';
import getDisplayName from '../../../utils/displayName';
import ModalView from '../ModalView';
import { LOCALIZED_STRINGS } from './constants';

export default function addInsuranceModal(WrappedComponent) {
    class AddInsuranceModal extends React.Component {
        static displayName = `AddInsuranceModal(${getDisplayName(WrappedComponent)})`;
        static WrappedComponent = WrappedComponent;

        static propTypes = {
            bookingSpotlightIsOn: PropTypes.bool,
            insuranceIsAccepted: PropTypes.bool,
            insuranceIsValidating: PropTypes.bool,
            locationId: PropTypes.string,
            providerId: PropTypes.string.isRequired,
            providerName: PropTypes.string,
        };

        static getDerivedStateFromProps(nextProps, prevState) {
            if (
                !nextProps.insuranceIsValidating &&
                (nextProps.insuranceIsAccepted !== prevState.cachedInsuranceIsAccepted)
            ) {
                /**
                 * on desktop, show modal on page load- on mobile,
                 * wait until user clicks book appointment button
                 */
                const displayReadyForModal = (
                    getWindowBreakpoint() > Breakpoints.medium ||
                    nextProps.bookingSpotlightIsOn
                );

                const nextState = {};

                if (nextProps.insuranceIsAccepted === false && displayReadyForModal) {
                    nextState.showModal = true;
                } else {
                    nextState.showModal = false;
                }

                nextState.cachedInsuranceIsAccepted = nextProps.insuranceIsAccepted;

                return nextState;
            }

            return {
                cachedInsuranceIsAccepted: nextProps.insuranceIsAccepted,
            };
        }

        state = {
            showModal: false,
        };

        mounted = false;

        componentDidMount() {
            this.mounted = true;
        }

        componentWillUnmount() {
            this.mounted = false;
        }

        render() {
            return (
                <div>
                    {this.state.showModal && this.renderModal()}
                    <WrappedComponent
                        {...this.props}
                        onChange={this.onChangeInsurance}
                    />
                </div>
            );
        }

        renderModal() {
            const { intl, providerName } = this.props;
            return (
                <Portal portalId="add-insurance-modal">
                    <ModalView
                        header={intl.formatMessage(LOCALIZED_STRINGS.ThisDoctorIsOutOfNetwork)}
                        message={intl.formatMessage(LOCALIZED_STRINGS.OutOfNetworkModalDescription, {
                            provider: providerName,
                            insuranceName: `${this.props.carrierName} - ${this.props.planName}`,
                        })}
                        onClickCancel={this.onClickCancel}
                        onClickPrimaryAction={this.onClickBookAnyway}
                        onClickSecondaryAction={this.onClickChangeInsurance}
                        primaryActionText={intl.formatMessage(LOCALIZED_STRINGS.BookAnyway)}
                        secondaryActionText={intl.formatMessage(LOCALIZED_STRINGS.ChangeInsurance)}
                    />
                </Portal>
            );
        }

        onChangeInsurance = insurance => this.props.onChange(insurance)

        onClickBookAnyway = () => {
            this.props.onClickBookAnyway();
            this.onClickCancel();
        }

        onClickChangeInsurance = () => {
            this.props.onClickChangeInsurance();
            this.onClickCancel();
        }

        onClickCancel = () => this.setState({ showModal: false })
    }

    return withInsuranceValidation(injectIntl(AddInsuranceModal));
}
